export default {
  data() {
    return {
      filters: [
        {
          label: this.$t("filters.myProjects"),
          switch: {
            name: "is_mine",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.isSend"),
          switch: {
            name: "is_posted",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.isVisited"),
          switch: {
            name: "is_visited",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.isPrivate"),
          switch: {
            name: "is_private",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.isSubscribed"),
          switch: {
            name: "is_subscribed",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.hasUploads"),
          switch: {
            name: "has_uploads",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.hasMessages"),
          switch: {
            name: "has_messages",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.hasDownloads"),
          switch: {
            name: "has_downloads",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.hasFileSignings"),
          switch: {
            name: "has_file_signings",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.isArchived"),
          switch: {
            name: "is_archived",
            model: true,
          },
          checkbox: true,
        },
        {
          label: this.$t("filters.hasFilePreviews"),
          switch: {
            name: "has_file_previews",
            model: true,
          },
          checkbox: true,
        },

        {
          label: this.$t("filters.withStatus"),
          select: {
            name: "with_status",
            multiple: true,
            model: null,
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectStatus"),
            wrap: true,
            searchable: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: true,
        },
        {
          label: this.$t("filters.withoutStatus"),
          select: {
            name: "without_status",
            multiple: true,
            model: null,
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectStatus"),
            wrap: true,
            searchable: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: true,
        },
        {
          label: this.$t("filters.withTemplate"),
          select: {
            name: "with_template",
            multiple: true,
            model: [],
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectTemplate"),
            wrap: true,
            searchable: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: true,
        },
        {
          label: this.$t("filters.withoutTemplate"),
          select: {
            name: "without_template",
            multiple: true,
            model: [],
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectTemplate"),
            wrap: true,
            searchable: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: true,
        },
        {
          label: this.$t("filters.withUser"),
          select: {
            name: "with_user",
            multiple: true,
            model: [],
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectUser"),
            wrap: true,
            searchable: true,
            internalSearch: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: false,
        },
        {
          label: this.$t("filters.withoutUser"),
          select: {
            name: "without_user",
            multiple: true,
            model: [],
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectUser"),
            wrap: true,
            searchable: true,
            internalSearch: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: false,
        },
        {
          label: this.$t("filters.withContact"),
          select: {
            name: "with_contact",
            multiple: true,
            model: [],
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectContact"),
            wrap: true,
            searchable: true,
            internalSearch: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: false,
        },
        {
          label: this.$t("filters.withoutContact"),
          select: {
            name: "without_contact",
            multiple: true,
            model: [],
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectContact"),
            wrap: true,
            searchable: true,
            internalSearch: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: false,
        },
        {
          label: this.$t("filters.withTags"),
          select: {
            name: "with_tag",
            multiple: true,
            model: [],
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectTag"),
            wrap: true,
            searchable: true,
            internalSearch: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: false,
        },
        {
          label: this.$t("filters.withoutTags"),
          select: {
            name: "without_tag",
            multiple: true,
            model: [],
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectTag"),
            wrap: true,
            searchable: true,
            internalSearch: true,
            searchChange: () => {},
          },
          checkbox: true,
          hideIfNoOptions: false,
        },
        {
          label: this.$t("filters.timeFilter"),
          filterGroup: "timeFilter",
          select: {
            name: "time_col",
            multiple: false,
            model: [],
            preselectModel: {
              label: this.$t("filters.created_at"),
              value: "created_at",
            },
            direction: "top",
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectTimeColumn"),
            wrap: true,
            searchable: false,
            searchChange: () => {},
          },
          style: "width: 250px;",
          hideIfNoOptions: true,
        },
        {
          label: this.$t("filters.timeFilter"),
          filterGroup: "timeFilter",
          isCondition: {
            name: ["time_from", "time_to"],
            value: "custom",
          },
          select: {
            name: "time_relative",
            multiple: false,
            model: [],
            preselectModel: {
              label: this.$t("filters.timeRelative.today"),
              value: "today",
            },
            direction: "top",
            options: [],
            label: "label",
            placeholder: this.$t("placeholders.selectTimeRelative"),
            wrap: true,
            searchable: false,
            searchChange: () => {},
          },
          style: "width: 250px;",
          hideIfNoOptions: true,
        },
        {
          label: this.$t("filters.timeFilter"),
          filterGroup: "timeFilter",
          conditional: {
            name: "time_relative",
            value: "custom",
          },
          dateTimeRange: {
            name: ["time_from", "time_to"],
            model: [],
            lang: "de",
            placeholder: "Placeholder",
          },
          hideIfNoOptions: true,
        },
      ],
      groups: {
        timeFilter: {
          label: this.$t("filters.timeFilter"),
          hoverBg: true,
          checkbox: true,
          method: () => {},
        },
      },
    };
  },
};
